import React, { Suspense } from 'react';
import { registerWorkspaceHostAuth } from '../../auth/registerWorkspaceHostAuth';

// Remote lazy loaders for workspace tab pages opened via "View in tab".
// Each import string must be a static literal for Vite Module Federation.

const DataDrivenInsightsRemote = React.lazy(async () => {
  const [module] = await Promise.all([
    // @ts-expect-error kciWorkspace is a Module Federation remote defined in vite.config.ts
    import('kciWorkspace/DataDrivenInsightsPage'),
    registerWorkspaceHostAuth(),
  ]);
  const component =
    module.DataDrivenInsightsPage ?? module.default?.DataDrivenInsightsPage ?? module.default;
  if (!component) throw new Error('DataDrivenInsightsPage not found in kciWorkspace');
  return { default: component as React.ComponentType<{ storageKey: string }> };
});

const DataDrivenAssessmentRemote = React.lazy(async () => {
  const [module] = await Promise.all([
    // @ts-expect-error kciWorkspace is a Module Federation remote defined in vite.config.ts
    import('kciWorkspace/DataDrivenAssessmentPage'),
    registerWorkspaceHostAuth(),
  ]);
  const component =
    module.DataDrivenAssessmentPage ?? module.default?.DataDrivenAssessmentPage ?? module.default;
  if (!component) throw new Error('DataDrivenAssessmentPage not found in kciWorkspace');
  return { default: component as React.ComponentType<{ storageKey: string }> };
});

const ViewReportRemote = React.lazy(async () => {
  const [module] = await Promise.all([
    // @ts-expect-error kciWorkspace is a Module Federation remote defined in vite.config.ts
    import('kciWorkspace/ViewReportPage'),
    registerWorkspaceHostAuth(),
  ]);
  const component =
    module.ViewReportPage ?? module.default?.ViewReportPage ?? module.default;
  if (!component) throw new Error('ViewReportPage not found in kciWorkspace');
  return { default: component as React.ComponentType<{ storageKey: string }> };
});

export const RemoteDataDrivenInsightsDashboard = React.memo(function RemoteDataDrivenInsightsDashboard({
  storageKey,
}: {
  storageKey: string;
}) {
  return (
    <Suspense fallback={<div className="body-content">Loading Data-driven Insights…</div>}>
      <DataDrivenInsightsRemote key={storageKey} storageKey={storageKey} />
    </Suspense>
  );
});

export const RemoteDataDrivenAssessmentDashboard = React.memo(function RemoteDataDrivenAssessmentDashboard({
  storageKey,
}: {
  storageKey: string;
}) {
  return (
    <Suspense fallback={<div className="body-content">Loading Data-Driven Assessment…</div>}>
      <DataDrivenAssessmentRemote key={storageKey} storageKey={storageKey} />
    </Suspense>
  );
});

export const RemoteViewReportDashboard = React.memo(function RemoteViewReportDashboard({
  storageKey,
}: {
  storageKey: string;
}) {
  return (
    <Suspense fallback={<div className="body-content">Loading report…</div>}>
      <ViewReportRemote key={storageKey} storageKey={storageKey} />
    </Suspense>
  );
});
